import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter, InitializeFilterDropdown } from "../../../../shared/scripts/filtering";
import { getData } from "./site.utilities";

export class CTMSSiteAddressesSection implements IFilter {

    items: any[];
    itemsTable: any;
    tableSelector = '#addressesTable';
    searchSelector = '#address-search';
    clearSelector = '#address-search-clear';

    url: string;
    showSiteColumn: boolean;

    constructor(handlerUrl: string, showSiteColumn = true) {
        this.url = handlerUrl;
        this.showSiteColumn = showSiteColumn;

        this.initialize();
    }

    initialize() {
        this.itemsTable = $(this.tableSelector).DataTable({
            "dom": 'lrtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: false,
            scrollX: true,
            scrollY: '200px',
            scrollCollapse: true,
            order: [[0, 'asc']],
            orderCellsTop: true,
            columns: [
                { data: 'Type', title: 'Type', className: '' },
                { data: 'Address', title: 'Address', className: '' },
                { data: 'CityState', title: 'City, State', className: '' },
                {
                    data: 'Notes',
                    title: 'Notes',
                    className: '',
                    render: function (data) {
                        if (!data) return "";
                        const escaped = $('<div>').text(data).html();

                        return `<span 
                                    class="ctms-table-notes"
                                    data-toggle="tooltip"
                                    data-template="<div class='tooltip ctms-notes-tooltip' role='tooltip'><div class='arrow'></div><div class='tooltip-inner'></div></div>"
                                    title="${escaped}">
                                    ${escaped}
                                </span>`;
                    }
                },
                { 
                    data: 'Studies', 
                    title: 'Study', 
                    className: '',
                    render: function (data) {
                        return Array.isArray(data) ? data.join(", ") : "";
                    }
                },
                {
                    data: null,
                    title: "",
                    className: "ctms-table-col-actions",
                    orderable: false,
                    render: function (data, type, row) {
                        return `<button title="Edit"><i class="ctms-icon-pencil"></i></button>`;
                    }
                }
            ]
        });

        InitializeFilterDropdown('#address-type', [], this);
        InitializeFilterDropdown('#address-study', [], this);

        $(this.searchSelector).on('input', (evt) => {
            $(this.tableSelector).DataTable().search(String($(evt.target).val() ?? '')).draw();
        });
        $(this.clearSelector).on('click', (evt) => {
            $(this.searchSelector).val('');
            $(this.tableSelector).DataTable().search('').draw();
        });
    }

    async loadData() {
        $('#addressSectionLoading').removeClass('d-none');

        this.items = await getData(this.url);

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();
        $('[data-toggle="tooltip"]').tooltip({
            container: 'body',
            placement: 'auto'
        });

        // Update filters
        const typeValues: string[] = Unique(this.items.map(a => a.Type), true).sort();
        $('#address-type').empty();
        $('#address-type').append(typeValues.map(e => new Option(e, e, false, true)));
        $('#address-type').selectpicker("refresh");

        const studyValues = Unique(this.items.map(a => a.Studies).flat(), true).sort();
        $('#address-study').empty();
        $('#address-study').append(studyValues.map(e => new Option(e, e, false, true)));
        $('#address-study').selectpicker("refresh");

        $('#addressSectionLoading').addClass('d-none');
    }

    triggerFilter() {
        const type = $('#address-type').val() as [any];
        const study = $('#address-study').val() as [any];

        const filteredItems = this.items.filter((a) => {
            const studyMatch = a.Studies.some((s: string) => study.includes(s));
            return type.includes(a.Type) && studyMatch;
        });

        this.itemsTable.clear();
        this.itemsTable.rows.add(filteredItems).draw();
    }

    resetFilters() {
        $('#address-type').selectpicker('selectAll');
        $('#address-type').selectpicker('refresh');

        $('#address-study').selectpicker('selectAll');
        $('#address-study').selectpicker('refresh');

        this.itemsTable.clear();
        this.itemsTable.rows.add(this.items).draw();
    }
}
